import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import sealing from "../../assets/img/SEALING-SERVICES.jpg";
import online from "../../assets/img/SERVICES.jpg";
import hologram from "../../assets/img/HOLOGRAM-SECURITY.jpg";

import { Link } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

const ServicesSummary = () => {
  return (
    <>
      <section className="section-spacing-x section-spacing-y">
        <Container fluid>
          <div>
            <h1 className="heading mb-3 text-center">
              Best Diamond Certification Service in India
            </h1>

            <p className="para-content mb-1">
              We know the diamond industry moves quickly, and diamantaires need
              certificates in hours to ensure a sale. We offer the best diamond
              certification service in India, combining security, convenience,
              and advanced technology. Preliminary Examination - Clients often
              require an initial examination of the stone, dealing with color
              and clarity, before ordering a full grading report. The details
              are kept in a different file and remain as the basis of our
              examination for one year from the date of inspection. As soon as
              the diamond's preliminary examination is completed, it is
              automatically sent to the transit section of the SHDL lab. We will
              then provide you with the results of the preliminary examination
              via WhatsApp, whichever is most convenient for you. Based on these
              results, you can decide which type of certificate best suits your
              requirements and which additional services you need. Meanwhile,
              the diamond will remain in transit until you give us further
              instructions.{" "}
            </p>
            <p className="mb-1">
              Trust Sreehari Diamond Lab for reliable, cutting-edge solutions to
              safeguard and certify your precious gems with utmost precision.{" "}
            </p>

            <Row className="mt-4">
              <div className="col-lg-4 mb-lg-0 mb-3">
                <div className="service-card text-center border rounded ">
                  <div className="service-image mx-auto">
                    <img src={sealing} alt="service" className="img-fluid" />
                  </div>
                  <Link to="/diamond-sealing-service">
                    <h3 className="mt-0">Sealing Service</h3>
                  </Link>
                  <p className="mt-0">
                    Our Sealing Service ensures your diamonds are protected in
                    tamper-proof holders, preserving authenticity and value.{" "}
                  </p>
                  <div className="service-read-more">
                    <Link to="/diamond-sealing-service">
                      Read More
                      <MdKeyboardDoubleArrowRight />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-lg-0 mb-3">
                <div className="service-card text-center border rounded">
                  <div className="service-image mx-auto">
                    <img src={online} alt="service" className="img-fluid" />
                  </div>
                  <Link to="/online-certificate-verification">
                    <h3 className="mt-0">Online Service</h3>
                  </Link>

                  <p className="mt-0">
                    With our Online Service, you can easily submit your
                    gemstones remotely and receive detailed grading reports
                    without visiting the lab.{" "}
                  </p>
                  <div className="service-read-more">
                    <Link to="/online-certificate-verification">
                      Read More
                      <MdKeyboardDoubleArrowRight />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="service-card text-center border rounded">
                  <div className="service-image mx-auto">
                    <img
                      src={hologram}
                      alt="Diamond Hologram Security Stickers | Sreehari Diamond Laboratory"
                      className="img-fluid"
                    />
                  </div>
                  <Link to="/diamond-hologram-stickers">
                    <h3 className="mt-0">Hologram Security </h3>
                  </Link>

                  <p className="mt-0">
                    Our innovative Hologram Service adds a securse,
                    anti-counterfeit layer to every certified diamond,
                    guaranteeing easy verification.{" "}
                  </p>
                  <div className="service-read-more">
                    <Link to="/diamond-hologram-stickers">
                      Read More
                      <MdKeyboardDoubleArrowRight />
                    </Link>
                  </div>
                </div>
              </div>{" "}
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default ServicesSummary;
